// 导入高德地图工具函数
export { getAMap, BD09toGCJ02, GCJ02toBD09, WGS84toGCJ02 } from "./amap"

export function getBMap(ak: string) {
  return new Promise(function (resolve, reject) {
    if (typeof window.BMap !== "undefined") {
      resolve(window.BMap)
      return true
    }
    window.onBMapCallback = function () {
      resolve(window.BMap)
    }
    const script = document.createElement("script")
    script.type = "text/javascript"
    script.src = "//api.map.baidu.com/api?v=3.0&ak=" + ak + "&__ec_v__=20190126&callback=onBMapCallback"
    script.onerror = reject
    document.head.appendChild(script)
  })
}

export function getWebGlBMap(ak: string) {
  return new Promise(function (resolve, reject) {
    if (typeof window.BMapGL !== "undefined") {
      resolve(window.BMapGL)
      return true
    }
    window.onBMapGLCallback = function () {
      resolve(window.BMapGL)
    }
    const script = document.createElement("script")
    script.type = "text/javascript"
    script.src = "//api.map.baidu.com/api?v=1.0&type=webgl&ak=" + ak + "&callback=onBMapGLCallback"
    script.onerror = reject
    document.head.appendChild(script)
  })
}

/**
 * 字符串截取
 * @param text
 * @param length
 * @returns
 */
export function cutText(text: string, length: number) {
  if (text.length > length) {
    return text.substring(0, length) + "..."
  } else {
    return text
  }
}

/**
 * 百分比比率计算器 （解决四舍五入后各项总和低于 100 或者高于 100 的问题）
 * @param list 数据列表
 * @param key 要计算的数据项健名
 * @param percentKey 将计算结果保存到数据项的健名
 * @param totalCount 传入总和项的值，如果不传入则会自动计算数据列表中所有项的总和
 * @returns
 */
export function countPercentage(
  list: { [key: string]: number | string }[],
  key: string | string[],
  percentKey: string,
  totalCount?: number,
): { [key: string]: number | string }[] {
  let total = totalCount || 0

  if (!totalCount) {
    list.forEach(item => {
      if (Array.isArray(key)) {
        key.forEach(k => {
          total += Number(item[k])
        })
      } else {
        total += Number(item[key])
      }
    })
  }

  if (total === 0) {
    list.forEach(item => {
      item[percentKey] = 0
    })
    return list
  }
  // 计算 list 中每一项的百分比，并确保总数不超过 100%
  list.reduce((restPer, item) => {
    let count = 0
    if (Array.isArray(key)) {
      key.forEach(k => {
        count += Number(item[k])
      })
    } else {
      count = Number(item[key])
    }
    let percentage = parseFloat(((count / total) * 100).toFixed(2))
    if (restPer - percentage < 0) {
      percentage = restPer
    }
    item[percentKey] = percentage
    return parseFloat((restPer - percentage).toFixed(2))
  }, 100)

  return list
}

/**
 * 加减乘函数（解决 js 计算精度的问题）
 * @param val1
 * @param symbol
 * @param val2
 * @returns
 */
export function actionOperationResult(val1: number, symbol: string, val2: number): number {
  const len1 = val1.toString().length - val1.toString().indexOf(".") - 1
  const len2 = val2.toString().length - val2.toString().indexOf(".") - 1
  const p = Math.max(len1, len2)
  // 避免最终求出结果的长度大于最大长度的时候导致精度丢失 开启下面
  // p += p - Math.min(len1, len2);
  const num = Math.pow(10, p)
  switch (symbol) {
    case "+": {
      return (parseFloat((val1 * num).toFixed(2)) + parseFloat((val2 * num).toFixed(2))) / num
    }
    case "-": {
      return (parseFloat((val1 * num).toFixed(2)) - parseFloat((val2 * num).toFixed(2))) / num
    }
    case "*": {
      return (parseFloat((val1 * num).toFixed(2)) * parseFloat((val2 * num).toFixed(2))) / (num * num)
    }
    default:
      throw new Error("symbol is not supported")
  }
}

/**
 * 数值格式化
 * @param val
 * @returns
 */
export function numberFormat(val: number): string {
  const param = {} as { [key: string]: string | number }
  const k = 10000
  const sizes = ["", "万", "亿", "万亿"]
  let i: number
  if (val < k) {
    param.value = val
    param.unit = ""
  } else {
    i = Math.floor(Math.log(val) / Math.log(k))
    param.value = parseFloat((val / Math.pow(k, i)).toFixed(2))
    param.unit = sizes[i]
  }
  return `${param.value}${param.unit}`
}

export const deleteEmptyKey = obj => {
  Object.keys(obj).forEach(key => {
    if (typeof obj[key] === "undefined") {
      delete obj[key]
    }
  })
}
// 去除css尺寸中的px
export const removePx = (str: string) => {
  return str.replace("px", "")
}

export const checkGeoInside = (path: { lng: number; lat: number }[], point: { lng: number; lat: number }): boolean => {
  let inside = false
  // 射线法判断算法
  for (let i = 0, j = path.length - 1; i < path.length; j = i++) {
    const xi = path[i].lng,
      yi = path[i].lat
    const xj = path[j].lng,
      yj = path[j].lat
    const intersect = yi > point.lat !== yj > point.lat && point.lng < ((xj - xi) * (point.lat - yi)) / (yj - yi) + xi
    if (intersect) {
      inside = !inside
    }
  }
  return inside
}

export function calcPropsBindData(componentConfig, componentClass) {
  if (!componentClass || typeof componentClass === "string") {
    const { ...config } = componentConfig
    return config
  }
  const { props } = componentClass
  if (!props) {
    return null
  }
  const propKeys = Object.keys(props)
  const result = {}
  propKeys.map(key => {
    result[key] = componentConfig[key]
  })
  if (componentConfig.id) {
    result["data-component-id"] = componentConfig.id
    result["id"] = componentConfig.id
  }
  return result
}

export function calcGroupOffset(position) {
  const {
    top = undefined,
    left = undefined,
    right = undefined,
    bottom = undefined,
    offset = undefined,
    zIndex = 1,
    width = undefined,
    height = undefined,
  } = position

  function getOffsetValue(value, target) {
    let result = "0"
    const targetPositionValue = position[target]

    if (!targetPositionValue) {
      if (typeof value === "string") {
        result = value
      } else {
        result = `${value}px`
      }
    } else {
      if (typeof value != "number") {
        // 如果数值，不进行计算，直接返回
        return value
      } else {
        const targetPureNum = parseFloat(targetPositionValue.match(/[-]?[0-9]+/g))
        result = targetPositionValue.replace(/[-]?[0-9]+/g, targetPureNum + value)
      }
    }
    return result
  }

  const result: any = {
    zIndex,
    width,
    height,
  }

  if (offset) {
    const { top: offsetTop = undefined, bottom: offsetBottom = undefined, left: offsetLeft = undefined, right: offsetRight = undefined } = offset
    if (offsetTop) {
      result.top = getOffsetValue(offsetTop, "top")
    }

    if (offsetBottom) {
      result.bottom = getOffsetValue(offsetBottom, "bottom")
    }

    if (offsetLeft) {
      result.left = getOffsetValue(offsetLeft, "left")
    }

    if (offsetRight) {
      result.right = getOffsetValue(offsetRight, "right")
    }
  } else {
    if (top) {
      result.top = top
    }

    if (left) {
      result.left = left
    }

    if (right) {
      result.right = right
    }

    if (bottom) {
      result.bottom = bottom
    }
  }
  return result
}
